import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

const userScheme = Yup.object().shape({
  firstName: Yup.string().required('Required Field'),
  lastName: Yup.string().required('Required Field'),
  branch: Yup.string().required('Required Field'),
  email: Yup.string().required('Required Field'),
  // Password is only required when creating a brand new login. When the email
  // belongs to a user who already exists (being added to another branch), they
  // already have a login, so no password is collected.
  password: Yup.string().when(['isEdit', 'existingUser'], {
    is: (isEdit, existingUser) => !isEdit && !existingUser,
    then: () =>
      Yup.string()
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/,
          'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number'
        )
        .min(8, 'Must be at least 8 characters')
        .required('Required Field')
  }),
  confirmPassword: Yup.string().when(['isEdit', 'existingUser'], {
    is: (isEdit, existingUser) => !isEdit && !existingUser,
    then: () =>
      Yup.string()
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
        .required('Required Field')
  }),
  adminPassword: Yup.string().when('superAdmin', {
    is: true,
    then: () =>
      Yup.string().required(
        'Password verification is required to assign Super Admin privileges'
      )
  })
});

const userResolver = yupResolver(userScheme);

export { userResolver };
